export interface AccessDetails {
  name: string;
  login: string;
  /** Opcional: vazio, a mensagem não fala de e-mail. */
  email: string;
  password: string;
  /** Endereço oficial da plataforma — a primeira origem de CORS_ORIGINS. */
  url: string;
}

/**
 * O acesso de um membro numa mensagem pronta para mandar (WhatsApp, e-mail):
 * endereço, usuário, e-mail quando houver, e a senha.
 */
export function formatAccessMessage({ name, login, email, password, url }: AccessDetails): string {
  const firstName = name.trim().split(/\s+/)[0] ?? '';
  const mail = email.trim().toLowerCase();
  return [
    firstName ? `Olá, ${firstName}! Seu acesso à plataforma:` : 'Seu acesso à plataforma:',
    '',
    `Endereço: ${url}`,
    `Usuário: ${login}`,
    ...(mail ? [`E-mail: ${mail}`] : []),
    `Senha: ${password}`,
    '',
    mail
      ? 'Você pode entrar com o usuário ou com o e-mail. Depois de entrar, troque a senha em "Minha conta".'
      : 'Entre com o usuário. Depois de entrar, troque a senha em "Minha conta".',
  ].join('\n');
}
